import React from 'react';
import { Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { BaseDialog } from 'src/components/BaseDialog/BaseDialog';
import { ts } from 'src/utils/translate';

type Props = {
    open: boolean;
    disabled: boolean;
    onClose: () => void;
    onConfirm: () => void;
};

export const DeleteAccountDialog = ({ open, disabled, onClose, onConfirm }: Props) => {
    // the legacy translation separates the lines with <br>
    const messageLines = ts(
        'pr_accdel_msg',
        "You'll permanently lose your<br> - Profile<br> - Projects<br> - Custom items<br><br> To continue, click delete button below."
    ).split('<br>');

    return (
        <BaseDialog
            open={open}
            onClose={onClose}
            title={ts('pr_accdel_title', 'Delete Account?')}
            titleIcon={<DeleteIcon color="error" />}
            maxWidth="xs"
            cancelLabel={ts('plt_cancel', 'Cancel')}
            actionLabel={ts('pr_accdel_ok', 'Delete my account')}
            actionDisabled={disabled}
            onAction={onConfirm}
        >
            {messageLines.map((line, index) => (
                <Typography key={index} variant="body2" sx={{ minHeight: '1.43em' }}>
                    {line}
                </Typography>
            ))}
        </BaseDialog>
    );
};
